/**
 * Focused compatibility surface for generated display-image contracts.
 *
 * Image sizing code predates the generated contract and uses PascalCase member names. Keeping
 * that naming adaptation here avoids duplicating either the enum values or the image wire shape.
 */
import { DisplayImageCdn as GeneratedDisplayImageCdn } from './api/generated';
import type { DisplayImage as GeneratedDisplayImage } from './api/generated';

/** Application-facing names for the generated image CDN identifiers. */
export const DISPLAY_IMAGE_CDN = {
  Amazon: GeneratedDisplayImageCdn.amazon,
  Walmart: GeneratedDisplayImageCdn.walmart,
  Shopify: GeneratedDisplayImageCdn.shopify,
  Static: GeneratedDisplayImageCdn.static,
} as const;

/** Generated image URL and the provider contract used to size it. */
export type DisplayImage = GeneratedDisplayImage;
